/* eslint-disable react/prop-types */
import React from 'react'
import _ from 'lodash'
import { withTranslation } from 'react-i18next'

import AnnouncementRow from './AnnouncementRow'

class AnnouncementTable extends React.Component {
  DATE_KEY = 'created_at'

  constructor(props, context) {
    super(props, context)
    this.state = {
      sortBy: this.DATE_KEY,
      sortByReverse: true,
    }
  }

  handleSortBy = key => {
    this.setState(prevState => ({
      sortBy: key,
      sortByReverse: !prevState.sortByReverse,
    }))
  }

  renderRows = (announcements, sortBy, sortByReverse) => {
    if (!_.isEmpty(announcements)) {
      const announcementsWithClasses = announcements.map(a => {
        a.classes = _.map(a.courses, 'name').join(', ')
        return a
      })
      const sortedAnnouncements = _.sortBy(
        announcementsWithClasses,
        announcement => announcement[sortBy]
      )
      if (sortByReverse) { sortedAnnouncements.reverse() }
      return sortedAnnouncements.map((announcement, _index) => (
        <AnnouncementRow
          key={announcement.id}
          announcement={announcement}
          toggleModal={this.props.toggleModal}
        />
      ))
    }
  }

  getSortIcon = (sortBy, _sortByType) => {
    const sortDirection = this.state.sortByReverse ? 'desc' : 'asc'
    const iconClass = `fa fa-sort-${sortDirection}`
    return sortBy === this.state.sortBy ? (
      <i className={iconClass} aria-hidden='true' />
    ) : (
      <i className='fa fa-sort' aria-hidden='true' />
    )
  }

  render() {
    const { t } = this.props
    const announcements = JSON.parse(JSON.stringify(this.props.announcements))
    return (
      <div className='animated fadeIn'>
        <div className='hidden-md-up '>
          <button
            onClick={() => this.handleSortBy(this.DATE_KEY)}
            className='btn float-right btn-link m-0 '
          >
            {t('common.field.date')} {this.getSortIcon(this.DATE_KEY, 'numeric')}
          </button>
        </div>
        <table className='table w-100'>
          <thead className='primary-background hidden-md-down'>
            <tr className='text-white font-200'>
              {/* <th className="font-200">Type</th> */}
              <th className='font-200'>{t('announcements.table.message')}</th>
              <th
                className='font-200'
                onClick={() => this.handleSortBy(this.DATE_KEY)}
              >
                {t('common.field.date')} {this.getSortIcon(this.DATE_KEY, 'numeric')}
              </th>
              <th className='font-200' />
            </tr>
          </thead>
          <tbody>
            {this.renderRows(
              announcements,
              this.state.sortBy,
              this.state.sortByReverse
            )}
          </tbody>
        </table>
      </div>
    )
  }
}

export default withTranslation()(AnnouncementTable)
